<template>
  <div class="relative h-auto bg-slate-50 pt-5 md:pt-5 lg:pt-0">
    <div
      class="hero-filter pointer-events-none z-0 hidden md:block lg:block"
    />
    <div class="mx-auto block max-w-3xl px-8 lg:flex lg:max-w-6xl lg:py-12">
      <div class="w-full lg:w-3/5">
        <div class="max-w-lg lg:max-w-xl">
          <span class="mb-1 block text-base text-gray-800 md:text-lg lg:text-lg">Taking the toil out of sustainability</span>
          <h1
            class="hero-title text-3xl font-semibold leading-tight tracking-tight text-gray-800 md:text-4xl lg:text-5xl lg:leading-tight"
          >
            Your one-stop Solution for Sustainability Data Management
          </h1>
        </div>
        <div class="mb-8 max-w-lg md:mb-10 lg:mb-14 lg:max-w-lg">
          <p class="mt-6 text-base text-gray-500 md:text-base lg:text-base">
            Measure, analyze, report, and reduce your emissions with our
            comprehensive carbon management system that seamlessly integrates
            across your value chain and provides unparalleled granularity and
            visibility into your sustainability progress.
          </p>
        </div>
        <div class="flex gap-3 md:space-x-3">
          <NuxtLink
            to="/login/"
            aria-current="page"
            class="block w-full select-none rounded-md border-2 border-green-800/50 bg-green-700 px-5 py-3 text-center text-sm font-normal text-white hover:bg-green-800 active:bg-green-700 lg:w-auto lg:px-10 lg:py-4 lg:text-sm"
          >
            <span>Log in</span>
          </NuxtLink>
        </div>
      </div>

      <div class="relative w-full lg:w-2/5">
        <div class="absolute -top-10 right-12 z-20 hidden md:hidden lg:block">
          <NuxtImg
            src="/website/scribble-01.svg"
            class="w-26"
            alt="Scribble"
          />
        </div>
        <div class="absolute -bottom-16 -left-20 hidden md:hidden lg:block">
          <NuxtImg
            src="/website/scribble-02.svg"
            class="w-24"
            alt="Scribble"
          />
        </div>
        <div
          class="hero-image-wrapper relative h-full w-full lg:h-full lg:w-80 lg:rounded-lg lg:border-4 lg:border-gray-200 lg:bg-gray-200"
        >
          <img
            src="/website/veridis-hero.png"
            class="relative mx-auto mt-10 h-full w-52 md:relative md:mx-auto md:mt-10 md:w-64 lg:absolute lg:-top-10 lg:mx-0 lg:mt-0 lg:w-auto lg:scale-125"
            alt="A woman holding a tablet tracking carbon emissions using Veridis"
          >
        </div>
        <div
          class="absolute bottom-0 right-0 w-60 md:right-20 md:w-72 lg:-bottom-36 lg:-right-32 lg:w-auto"
        >
          <NuxtImg
            src="/website/emission-cards.svg"
            width="450"
            alt="Total emissions cards illustration inside Veridis"
          />
        </div>
      </div>
    </div>
    <div class="mt-20 hidden lg:bottom-0 lg:block">
      <NuxtImg
        src="/website/site-divider.svg"
        class="w-full"
        alt="Page divider"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSection',

  mounted() {
    this.textReveal()
  },

  methods: {
    textReveal() {
      const gsap = this.$gsap.timeline()
      gsap.from('.title-animate', 1.8, {
        y: 100,
        ease: 'power4.out',
        delay: 1,
        skewY: 7,
        stagger: {
          amount: 0.3,
        },
      })
    },

    scrollElementOnMove() {
      const gsap = this.$gsap
      gsap.to('.moving', {
        yPercent: -20,
        ease: 'none',
        scrollTrigger: {
          trigger: '.moving',
          start: 'top center',
          end: 'bottom top',
          scrub: true,
        },
      })
    },
  },
}
</script>
